module.exports = __webpack_public_path__ + "img/DX.3975870a.png";